/**
 * Custom Quick View modal (Hızlı Bakış).
 * Loaded globally so dynamically injected product cards (e.g. product recommendations) work.
 */

function initModalGallery(modalRoot) {
  var gallery = modalRoot.querySelector('[data-modal-gallery]');
  if (!gallery || gallery.dataset.galleryInit === 'true') return;

  var track = gallery.querySelector('[data-gallery-track]');
  var viewport = gallery.querySelector('[data-gallery-viewport]');
  var originalSlides = gallery.querySelectorAll('[data-gallery-slide]:not([data-gallery-clone])');
  var dots = gallery.querySelectorAll('[data-gallery-dot]');
  var prevBtn = gallery.querySelector('[data-gallery-prev]');
  var nextBtn = gallery.querySelector('[data-gallery-next]');

  /* FIX: quick view — skip gallery init when no slides/images, modal still opens */
  if (!track || !viewport || originalSlides.length === 0) return;

  gallery.dataset.galleryInit = 'true';

  var slideCount = originalSlides.length;
  var currentIndex = slideCount > 1 ? 1 : 0;
  var touchStartX = 0;
  var touchDeltaX = 0;
  var transitionMs = 350;
  var slideWidth = 0;
  var isWrapping = false;

  function prepareCloneImages(slide) {
    slide.querySelectorAll('img').forEach(function (img) {
      img.loading = 'eager';
      if (img.dataset.src && !img.getAttribute('src')) {
        img.src = img.dataset.src;
      }
    });
  }

  if (slideCount > 1) {
    var firstClone = originalSlides[0].cloneNode(true);
    var lastClone = originalSlides[slideCount - 1].cloneNode(true);
    firstClone.setAttribute('data-gallery-clone', 'end');
    lastClone.setAttribute('data-gallery-clone', 'start');
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    prepareCloneImages(firstClone);
    prepareCloneImages(lastClone);
    track.insertBefore(lastClone, originalSlides[0]);
    track.appendChild(firstClone);
  }

  function measureSlides() {
    slideWidth = viewport.clientWidth;
    if (!slideWidth) return;

    track.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
      slide.style.flex = '0 0 ' + slideWidth + 'px';
      slide.style.width = slideWidth + 'px';
      slide.style.maxWidth = slideWidth + 'px';
    });
  }

  function setTransition(enabled) {
    track.style.transition = enabled
      ? 'transform ' + transitionMs + 'ms cubic-bezier(0.4, 0, 0.2, 1)'
      : 'none';
  }

  function logicalIndex(physicalIndex) {
    if (slideCount <= 1) return 0;
    if (physicalIndex === 0) return slideCount - 1;
    if (physicalIndex === slideCount + 1) return 0;
    return physicalIndex - 1;
  }

  function updateDots(physicalIndex) {
    var active = logicalIndex(physicalIndex);
    dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === active;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function setTransform(physicalIndex, animate) {
    measureSlides();
    setTransition(animate && !isWrapping);
    track.style.transform = 'translate3d(-' + physicalIndex * slideWidth + 'px, 0, 0)';
    updateDots(physicalIndex);
  }

  function goToPhysical(physicalIndex, animate) {
    currentIndex = physicalIndex;
    setTransform(currentIndex, animate);
  }

  function goToLogical(logical, animate) {
    if (slideCount <= 1) {
      goToPhysical(0, animate);
      return;
    }
    goToPhysical(logical + 1, animate);
  }

  function wrapIfNeeded() {
    if (slideCount <= 1) return;

    if (currentIndex === 0) {
      isWrapping = true;
      goToPhysical(slideCount, false);
      isWrapping = false;
    } else if (currentIndex === slideCount + 1) {
      isWrapping = true;
      goToPhysical(1, false);
      isWrapping = false;
    }
  }

  function next() {
    if (slideCount <= 1) return;
    goToPhysical(currentIndex + 1, true);
  }

  function prev() {
    if (slideCount <= 1) return;
    goToPhysical(currentIndex - 1, true);
  }

  track.addEventListener('transitionend', function (event) {
    if (event.target !== track || event.propertyName !== 'transform' || slideCount <= 1) return;
    wrapIfNeeded();
  });

  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var index = parseInt(dot.getAttribute('data-gallery-dot'), 10);
      if (!isNaN(index)) goToLogical(index, true);
    });
  });

  if (viewport && slideCount > 1) {
    viewport.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        touchDeltaX = event.touches[0].clientX - touchStartX;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function () {
        if (Math.abs(touchDeltaX) < 40) return;
        if (touchDeltaX < 0) next();
        else prev();
        touchDeltaX = 0;
      },
      { passive: true }
    );
  }

  measureSlides();
  goToPhysical(currentIndex, false);

  window.addEventListener('resize', function onResize() {
    if (!modalRoot.isConnected) {
      window.removeEventListener('resize', onResize);
      return;
    }
    setTransform(currentIndex, false);
  });
}

/**
 * FIX: cart toast — AJAX add-to-cart from quick view modal; dispatches cart:update for toast + bubble
 * @param {HTMLElement} modalRoot
 */
function setupModalAddToCart(modalRoot) {
  var form = modalRoot.querySelector('.modal-add-form');
  if (!form || form.dataset.cartAjaxInit === 'true') return;

  form.dataset.cartAjaxInit = 'true';

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (!window.Theme || !window.Theme.routes || !window.Theme.routes.cart_add_url) return;

    var formData = new FormData(form);
    var quantity = parseInt(String(formData.get('quantity') || '1'), 10);
    if (!quantity || quantity < 1) quantity = 1;

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        sectionIds.push(el.dataset.sectionId);
      }
    });
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
    }

    var addBtn = form.querySelector('.modal-add-btn');
    if (addBtn) addBtn.disabled = true;

    fetch(window.Theme.routes.cart_add_url, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error('Quick view add to cart failed:', response.message || response.description);
          return;
        }

        var titleEl = modalRoot.querySelector('.modal-product-title');
        var imgEl = modalRoot.querySelector('.modal-gallery__slide img');
        var productTitle = titleEl ? titleEl.textContent.trim() : '';
        var productImageUrl = imgEl ? imgEl.currentSrc || imgEl.src : '';

        if (productImageUrl) {
          try {
            var imgUrl = new URL(productImageUrl, window.location.origin);
            imgUrl.searchParams.set('width', '96');
            productImageUrl = imgUrl.toString();
          } catch (e) {
            productImageUrl = productImageUrl.replace(/([?&])width=\d+/, '$1width=96');
            if (!/width=\d+/.test(productImageUrl)) {
              productImageUrl += (productImageUrl.indexOf('?') >= 0 ? '&' : '?') + 'width=96';
            }
          }
        }

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: 'quick-view-modal',
              data: {
                source: 'product-form-component',
                itemCount: quantity,
                sections: response.sections,
                productTitle: productTitle,
                productImageUrl: productImageUrl,
              },
            },
          })
        );
      })
      .catch(function (error) {
        console.error('Quick view add to cart error:', error);
      })
      .finally(function () {
        if (addBtn) addBtn.disabled = false;
      });
  });
}

/**
 * FIX: quick view — resolve modal template only from the clicked button's card wrapper (never global ID).
 * @param {Element} triggerBtn
 * @returns {HTMLElement | null}
 */
function resolveModalTemplate(triggerBtn) {
  if (!triggerBtn) return null;

  var wrap = triggerBtn.closest('[data-quick-view-root]');
  if (!wrap) return null;

  var modalTemplate = wrap.querySelector('.custom-modal-template');
  return modalTemplate instanceof HTMLElement ? modalTemplate : null;
}

/**
 * @param {Element} triggerBtn
 */
function openModal(triggerBtn) {
  try {
    var modalTemplate = resolveModalTemplate(triggerBtn);
    if (!modalTemplate) return;

    /* FIX: quick view — close any open portal without document.getElementById */
    document.querySelectorAll('.active-modal-portal').forEach(function (portal) {
      if (portal.parentNode) portal.parentNode.removeChild(portal);
    });

    var clone = modalTemplate.cloneNode(true);
    clone.removeAttribute('id');
    clone.removeAttribute('hidden');
    clone.classList.add('active-modal-portal');
    clone.style.display = 'block';

    var closeBtn = clone.querySelector('.custom-modal-close');
    var overlay = clone.querySelector('.overlay-click-area');
    var modalContent = clone.querySelector('.custom-modal-content');
    var variantInput = clone.querySelector('input[name="id"]');
    var addBtn = clone.querySelector('.modal-add-btn');

    /* FIX: quick view — guard missing variant id so open never throws */
    if (addBtn && (!variantInput || !variantInput.value)) {
      addBtn.disabled = true;
    }

    var closeFunc = function () {
      if (modalContent) {
        modalContent.style.transform = 'scale(0.95)';
        modalContent.style.opacity = '0';
      }
      setTimeout(function () {
        if (clone.parentNode) clone.parentNode.removeChild(clone);
      }, 200);
    };

    if (closeBtn) closeBtn.onclick = closeFunc;
    if (overlay) overlay.onclick = closeFunc;

    document.body.appendChild(clone);
    setupModalAddToCart(clone);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        initModalGallery(clone);
      });
    });
  } catch (error) {
    console.error('Quick view failed to open:', error);
  }
}

function handleQuickViewActivate(event) {
  var triggerBtn = event.target.closest('[data-quick-view-trigger]');
  if (!triggerBtn) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  openModal(triggerBtn);
}

/* FIX: quick view — single document-level delegation for all sections and dynamic cards */
function setupQuickViewDelegation() {
  if (window.__quickViewDelegationInit) return;
  window.__quickViewDelegationInit = true;

  document.addEventListener('click', handleQuickViewActivate, true);
}

/**
 * Kept for product-recommendations.js and other dynamic injectors (delegation handles clicks).
 * @param {ParentNode} [_root]
 */
function initCustomQuickView(_root) {
  setupQuickViewDelegation();
}

window.openModal = openModal;
window.initCustomQuickView = initCustomQuickView;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupQuickViewDelegation);
} else {
  setupQuickViewDelegation();
}
